import { render } from "./CGU.vue?vue&type=template&id=bfe9c248&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"

import "./CGU.vue?vue&type=style&index=0&id=bfe9c248&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe9c248"]])

export default __exports__